import { useQuery, useMutation, keepPreviousData } from "@tanstack/react-query";
import api from "@services/api";

export function useTimeSlotsQuery(day) {
  return useQuery({
    queryKey: ["time-slots", day || "any"],
    queryFn: async () => {
      const { data } = await api.get("/time-slots", { params: { day } });
      const payload = data?.data ?? data ?? [];
      return Array.isArray(payload) ? payload : [];
    },
    staleTime: 5 * 60 * 1000
  });
}

async function fetchTimeSlotsAdmin(filters, page, pageSize) {
  const params = {
    day: filters.day || undefined,
    type: filters.type || undefined,
    status: filters.status || undefined,
    raw: 1,
    page,
    page_size: pageSize
  };
  const { data } = await api.get("/time-slots", { params });
  return data;
}

export function useTimeSlotsAdminQuery(filters, page, pageSize) {
  return useQuery({
    queryKey: ["time-slots-admin", filters, page, pageSize],
    queryFn: () => fetchTimeSlotsAdmin(filters, page, pageSize),
    placeholderData: keepPreviousData
  });
}

export function useCreateTimeSlotMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post("/time-slots", payload);
      return data;
    }
  });
}

export function useUpdateTimeSlotMutation() {
  return useMutation({
    mutationFn: async ({ id, payload }) => {
      const { data } = await api.patch(`/time-slots/${id}`, payload);
      return data;
    }
  });
}

export function useDeleteTimeSlotMutation() {
  return useMutation({
    mutationFn: async (id) => {
      await api.delete(`/time-slots/${id}`);
      return true;
    }
  });
}

